import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import * as fromAuth from '../../auth/reducers';
var MessagingWrapperComponent = /** @class */ (function () {
    function MessagingWrapperComponent(_store, _route) {
        this._store = _store;
        this._route = _route;
    }
    MessagingWrapperComponent.prototype.ngOnInit = function () {
        // Check clinic options to determine which messaging implementation to use
        this.useV3Messaging$ = this._store.pipe(select(fromAuth.getMessagingV3Enabled), map(function (enabled) { return (enabled !== undefined ? enabled : false); }));
    };
    return MessagingWrapperComponent;
}());
export { MessagingWrapperComponent };
